import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchAssociatedFundManager,
  fetchComapnyId,
  fetchFundManagerDetails,
  fetchPortfolioFundManager,
  fetchReferenceFundManager,
  fetchUpdateFundManager,
  fetchUpdateFundManagerJson,
} from '../Slice/FundActions';

export const getFundManagerDetails = createAsyncThunk(
  'fundManager/getDetail',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchFundManagerDetails(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCompanyID = createAsyncThunk(
  'fundmanager-page/getCompanyID',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchComapnyId(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateFundManagerDetails = createAsyncThunk(
  'fundManager/updateDetails',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchUpdateFundManager(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateFundManagerJson = createAsyncThunk(
  'fundManager/updateJson',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchUpdateFundManagerJson(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAssociatedFundManager = createAsyncThunk(
  'fundManager/getAssociatedFundManager',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchAssociatedFundManager(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getReferencesFundManager = createAsyncThunk(
  'fundManager/getReferencesFundManager',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchReferenceFundManager(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPortfolioFundManager = createAsyncThunk(
  'fundManager/getPortfolioFundManager',
  async (requestObject, { rejectWithValue }) => {
    try {
      const { data, status } = await fetchPortfolioFundManager(requestObject);
      return { data, status };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
